export const asSet = <TItem>(array: TItem[]) => {
  return Array.from(new Set(array));
};
